import {
  ROOT_URL_HOST,
  COMPANY_EMAIL,
  COMPANY_TELEGRAM_LINK,
  COMPANY_VK_LINK,
  COMPANY_LEGAL_NAME,
  COMPANY_PHONE_INTERNATIONAL,
  COMPANY_ACCREDITATION_NUMBER,
  FOOTER_DESCRIPTION,
  LOGO_SRC,
} from '@/shared/constants/contactConstants';
import {
  ORGANIZATION_SCHEMA_ID,
  WEBSITE_SCHEMA_ID,
  SCHEMA_LANGUAGE,
  SCHEMA_COUNTRY_CODE,
} from '@/shared/lib/schema';
import type { IOrganizationSchema, IWebSiteSchema } from '@/app/model/types/schema';

const SITE_NAME: string = 'Юрик.ру';
const SITE_URL: string = `${ROOT_URL_HOST}/`;

export const organizationShortData: IOrganizationSchema = {
  '@id': ORGANIZATION_SCHEMA_ID,
  name: SITE_NAME,
  url: SITE_URL,
};

export const organizationData: IOrganizationSchema = {
  ...organizationShortData,
  legalName: COMPANY_LEGAL_NAME,
  logo: { '@type': 'ImageObject', url: `${ROOT_URL_HOST}${LOGO_SRC}` },
  image: `${ROOT_URL_HOST}/og-image.png`,
  description: FOOTER_DESCRIPTION,
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    telephone: COMPANY_PHONE_INTERNATIONAL,
    email: COMPANY_EMAIL,
    areaServed: SCHEMA_COUNTRY_CODE,
    availableLanguage: 'ru',
  },
  sameAs: [COMPANY_TELEGRAM_LINK, COMPANY_VK_LINK],
  identifier: {
    '@type': 'PropertyValue',
    name: 'Реестр аккредитованных организаций Минцифры РФ',
    value: COMPANY_ACCREDITATION_NUMBER,
  },
  areaServed: { '@type': 'Country', name: 'Россия' },
};

export const webSiteShortData: IWebSiteSchema = {
  '@id': WEBSITE_SCHEMA_ID,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: { '@id': ORGANIZATION_SCHEMA_ID },
};

export const webSiteData: IWebSiteSchema = {
  ...webSiteShortData,
  inLanguage: SCHEMA_LANGUAGE,
};
